import { IApSbsItem, IBilledCenterForList, IBillingDetail, ISearchForList } from "../../models";
import { INotBilled } from "./actions";

export interface IBillingState {
    pending: IBillingDetail[],
    billedByCenter: IBilledCenterForList[],
    billedToCenter: IBilledCenterForList[],
    notBilled: INotBilled[],
    upcoming: IBillingDetail[],
    search: ISearchForList[],
    details: IBillingDetail | null,
    apSbsReport: IApSbsItem[]
}
